export default __webpack_public_path__ + "static/media/190629_190332_IMG_5995.ce86d0f8.jpg";